import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { getAllCoursesForAdmin } from "../lib/firebase";

// Admin "view as member", like Skool's (Dew, 2026-10-27): pick a tier and the whole site shows
// what a buyer of that tier sees. The toggle sits in the top bar, the black bar at the bottom while on.

let tiersOnce: Promise<string[]> | null = null;

function useTiers(enabled: boolean): string[] {
  const [tiers, setTiers] = useState<string[]>([]);
  useEffect(() => {
    if (!enabled) return;
    tiersOnce ??= getAllCoursesForAdmin().then((cs) =>
      [...new Set(cs.filter((c) => c.published).flatMap((c) => c.tiers))].sort()
    );
    tiersOnce.then(setTiers).catch(() => (tiersOnce = null));
  }, [enabled]);
  return tiers;
}

export function PreviewToggle() {
  const { canPreview, previewTier, setPreviewTier } = useAuth();
  const tiers = useTiers(canPreview);
  if (!canPreview || previewTier) return null;
  return (
    <button type="button" className="btn-ghost" disabled={!tiers.length} onClick={() => setPreviewTier(tiers[0])}>
      👁 ดูแบบนักเรียน
    </button>
  );
}

export function PreviewBar() {
  const { canPreview, previewTier, setPreviewTier } = useAuth();
  const tiers = useTiers(canPreview);
  if (!canPreview || !previewTier) return null;
  return (
    <div className="preview-bar" role="status">
      <span>👁 ดูในฐานะนักเรียน tier</span>
      <select value={previewTier} onChange={(e) => setPreviewTier(e.target.value)} aria-label="เลือก tier">
        {(tiers.includes(previewTier) ? tiers : [previewTier, ...tiers]).map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
      <button type="button" aria-label="ออกจากโหมดดูแบบนักเรียน" title="กลับเป็นแอดมิน" onClick={() => setPreviewTier(null)}>
        ✕
      </button>
    </div>
  );
}
